module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('login', {
    ref: "login",
    on: {
      "on-login": _vm.login
    }
  }, [_c('h1', {
    attrs: {
      "slot": "logo"
    },
    slot: "logo"
  }, [_vm._v("LOGO")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-413288a7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/login/demo.vue
// module id = 243
// module chunks = 3